/**
 * Volume minus: the speaker body with a minus beside it — turn the sound down.
 *
 * Progress shrinks the minus slightly and settles it back, mirroring its
 * plus sibling's swell. See VolumeSignBase for the drawing and the pulse.
 *
 * Color slots: 0 the speaker, 1 the minus.
 */import*as React from"react";import VolumeSign from"web/shared/icons/glyphs/VolumeSignBase";import{jsx as _jsx}from"react/jsx-runtime";// How far the minus shrinks at the trough of the pulse.
const SCALE_AT_PEAK=0.82;function VolumeMinusGlyph(props){return/*#__PURE__*/_jsx(VolumeSign,{vertical:false,scaleAtPeak:SCALE_AT_PEAK,progress:props.progress,colors:props.colors});}export default VolumeMinusGlyph;